import { createReducer, Action, on } from '@ngrx/store';
import * as actions from 'src/app/root-store/reporting-store/powerbi-report.actions';
import { LoadingTypes } from 'src/app/shared/models/enums/loading.enum';
import { PowerBiExportStatus } from 'src/app/reporting/reports/models/powerbi-export-status.model';

export interface PowerBiReportExportState {
    loading: LoadingTypes;
    status: PowerBiExportStatus;
}

export const initialPowerBiReportExportState: PowerBiReportExportState = {
    loading: LoadingTypes.INIT,
    status: null
};

export function powerBiReportExportReducer(state: PowerBiReportExportState, action: Action) {
    return createReducer(
        initialPowerBiReportExportState,

        on(actions.exportPowerBiReport, actions.getPowerBiReportExportStatus, (state, action) => ({
            ...state,
            loading: LoadingTypes.LOADING,
            documentResponse: null
        })),

        on(actions.exportPowerBiReportSuccess, actions.getPowerBiReportExportStatusSuccess, (state, action) => ({
            ...state,
            loading: LoadingTypes.LOADED,
            status: action.status
        })),

        on(actions.exportPowerBiReportFail, actions.getPowerBiReportExportStatusFail, (state, action) => ({
            ...state,
            loading: LoadingTypes.FAIL,
            status: null
        })),

        on(actions.clearPowerBiReport, (state, action) => ({
            ...initialPowerBiReportExportState
        }))
    )(state, action);
}
